/*
 * Suggest Tag Mixing for TagFormSelector
 */

import Storable from '@/mixins/storable';
import api from '../api/api';

export default {
  mixins: [Storable],
  inject: {
    $getParentEditor: {
      default: null,
    },
  },
  props: {
    suggestEndpoint: {
      type: String,
    },
  },
  data() {
    return {
      suggesting: false,
    };
  },
  computed: {
    storePath() {
      if (typeof this.$getParentEditor === 'function') {
        return this.$getParentEditor().storePath;
      }
      return '';
    },
    hasSuggests() {
      return !!this.suggestEndpoint;
    },
    draft() {
      return this.getters.draft || {};
    },
  },
  methods: {
    async suggestQueryCallback() {
      if (!this.suggestEndpoint) {
        return;
      }
      if (this.suggesting === true) {
        console.log('Already loading');
        return;
      }

      this.suggesting = true;
      try {
        const result = await api.suggestTags(this.suggestEndpoint, this.getSuggestPayload());

        console.log('Suggest tags result: ', result);

        const keys = Object.keys(result);
        for (let index = 0; index < keys.length; index += 1) {
          const key = keys[index];
          if (typeof this.draft[key] === 'undefined') {
            console.warn('Response field not present on draft! skipping field', key);
          } else {
            console.log('%cUpdating field from suggest tags', 'color:darkorange', key, result[key]);
            await this.dispatch('UPDATE_FIELD', { [key]: result[key].map(card => card.id) });
          }
        }

        // A veces, después de aplicar los cambios de los taxones sugeridos por el servicio el editor no detecta
        // correctamente que el draft ha sido modificado. Para intentar corregir ese problema, en el siguiente tick
        // aprovechamos para emitir nuestro propio valor, lo que desencadena el flujo de validación de los formularios
        // y nos asegura que se muestra el botón de guardado.
        // @see https://mgr.bitban.com/issues/102597
        await this.$nextTick();
        this.$emit('input', this.value);
      } catch (e) {
        console.error('Error suggesting tags: ', e);
      } finally {
        this.suggesting = false;
      }
    },
    getSuggestPayload() {
      return {
        title: this.draft.title || '',
        subtitle: this.draft.subtitle || '',
        kicker: this.draft.kicker || '',
        summary: this.draft.summary || [],
        signatureAuthorName: this.draft.signatureAuthorName || '',
        signaturePlace: this.draft.signaturePlace || '',
        body: this.draft.body || [],
        mainTaxonomyId: this.draft.mainTaxonomyId || {},
      };
    },
  },
};
